export const getCurrency = {
  // BYN: () => <img src="/icons/BYN-white.svg" className="inline ml-[4px] w-[9px]" alt="currency" />,
  STAR: () => <img src="/icons/tg_star.png" className="inline ml-[4px] w-[12px]" alt="currency" />,
  default: () => <img src="/icons/tg_star.png" className="inline ml-[4px] w-[12px]" alt="currency" />,
};
